module.exports = __webpack_public_path__ + "static/media/Darsena - Orange_DK Grey.25fdb06f.jpg";